import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import Card from "../../../../../../atoms/ActiveLearning/Card";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconLive } from "../../../../../../assets/images/ActiveLearning/icon_live.svg";

type Issue5MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue5Material = (props: Issue5MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          これまでのLessonを通じて、自分にはどのような強みがあるか、今後どのような未来を描きたいかを考えよう。
        </p>
      </div>
      {question1 && <TextArea />}
      <Card icon={<IconLive />} label={"TRY"} title={"グループワーク"}>
        ①グループをつくろう。
        <br />
        ②自分が振り返った内容を発表し合おう。
        <br />
        ③発表者の成長したポイント、「すごい」と思ったポイントを自由に共有しよう。
      </Card>
    </div>
  );
};
export default Issue5Material;
